<div class="box-item">
    <div class="header-box">
      <span class="material-icons md-48" [ngStyle]="{'color': color ? color : 'var(--orange-secundary)' }">{{icon}}</span>
      <p>{{description}}</p>
    </div>
    <button [routerLink]="route" [ngStyle]="{'background-color': color ? color : 'var(--orange-secundary)' }">{{name}}</button>
</div>